import { ContainerModule, interfaces, Container } from 'inversify';
import { IUserRepository } from './auth/IUserRepository';
import UserRepository from './auth/UserRepository';

import { IBaseRepository } from './base/IBaseRepository';
import BaseRepository from './base/BaseRepository';
import { IPermissionRepository } from './auth/IPermissionRepository';
import PermissionRepository from './auth/PermissionRepository';
import { INotificationRepository } from './auth/INotificationRepository';
import NotificationRepository from './auth/NotificationRepository';
import { IReportRepository } from './report/IReportRepository';
import ReportRepository from './report/ReportRepository';
import FlowRepository from './flow/FlowRepository';
import RequestRepository from './flow/RequestRepository';
import { IRequestRepository } from './flow/IRequestRepository';
import SmsRepository from './auth/SmsRepository';
import { ISmsRepository } from './auth/ISmsRepository';
import { IFlowRepository } from './flow/IFlowRepository';
import RadRepository from './rad/RadRepository';
import { IRadRepository } from './rad/IRadRepository';

const allRepositories = new ContainerModule((bind: interfaces.Bind) => {
  //auth
  bind<IUserRepository>(Symbol.for("IUserRepository")).to(UserRepository);
  bind<IPermissionRepository>(Symbol.for("IPermissionRepository")).to(PermissionRepository);
  bind<INotificationRepository>(Symbol.for("INotificationRepository")).to(NotificationRepository);
  bind<ISmsRepository>(Symbol.for("ISmsRepository")).to(SmsRepository);

  //base
  bind<IBaseRepository>(Symbol.for("IBaseRepository")).to(BaseRepository);

  
  //report
  bind<IReportRepository>(Symbol.for("IReportRepository")).to(ReportRepository);

  //Flow
  bind<IFlowRepository>(Symbol.for("IFlowRepository")).to(FlowRepository);
  bind<IRequestRepository>(Symbol.for("IRequestRepository")).to(RequestRepository);
 //rad
  bind<IRadRepository>(Symbol.for("IRadRepository")).to(RadRepository);

});


export default allRepositories;
